import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Box, CircularProgress, Divider, IconButton, SxProps, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

import { sxBackBtn } from './styles';

type TitleProps = {
  sx?: SxProps;
  title: string;
  onClose: () => void;
  count?: number;
  rightAdornment?: ReactNode;
  isLoading?: boolean;
};

const Title: FC<TitleProps> = ({ sx = {}, title, onClose, count, rightAdornment, isLoading }) => {
  return (
    <>
      <Box
        my={2}
        mx={2.5}
        display="flex"
        alignItems="center"
        flexDirection="row"
        justifyContent="space-between"
        sx={sx}
      >
        <Box my={0.5} display="flex" alignItems="center" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
          <IconButton onClick={onClose} sx={sxBackBtn} aria-label="Back">
            <ChevronLeftIcon />
          </IconButton>
          <Typography variant="h6" textTransform="capitalize">
            {title}
          </Typography>
          {count !== undefined && (
            <Typography variant="h6" fontWeight="400">
              &nbsp;({count})
            </Typography>
          )}
        </Box>
        <Box display="flex" alignItems="center" gap={1}>
          {isLoading && (
            <Box display="flex" justifyContent="center">
              <CircularProgress aria-label="Loading..." size={22} />
            </Box>
          )}
          {!!rightAdornment && rightAdornment}
        </Box>
      </Box>
      <Divider />
    </>
  );
};

export default Title;
